export enum AccountStatus {
  ACTIVE = 'Active',
  CLOSED = 'Closed',
  DELINQUENT = 'Delinquent',
  BLOCKED = 'Blocked',
  DORMANT = 'Dormant',
}
